import React from 'react';
import ReactDOM from 'react-dom/client';
import './i18n';
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken } from "firebase/messaging";
import './index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Landing from './pages/Landing';
import CookieBannerPage from './pages/CookieBannerPage';
// FIREBASE

const root = ReactDOM.createRoot(document.getElementById('root'));

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAkh_N53g-dkMl09KJ6ASLHH-chVFs0WmI",
  authDomain: "smartxapp-b2703.firebaseapp.com",
  projectId: "smartxapp-b2703",
  storageBucket: "smartxapp-b2703.firebasestorage.app",
  messagingSenderId: "190261353177",
  appId: "1:190261353177:web:bdb94c5baedf84b1d0fcc8",
  measurementId: "G-376X7M4CXJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

root.render(
    <Router>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/home" element={<Home messaging={messaging}/>} />
        <Route path="/register" element={<SignUp />} />
        <Route path="/product/" element={<CookieBannerPage />} />
      </Routes>
    </Router>
);

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered ✅', registration);
    })
    .catch((err) => {
      console.error('Service Worker registration failed ❌', err);
    });
}